/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * categorizes a product for all tenants
 * @export
 */
export const ProductCategory = {
    PrivateTrial: 'PRIVATE_TRIAL',
    PrivateSubscription: 'PRIVATE_SUBSCRIPTION',
    BusinessTrial: 'BUSINESS_TRIAL',
    BusinessSubscription: 'BUSINESS_SUBSCRIPTION',
    Combined: 'COMBINED',
    Service: 'SERVICE',
    Other: 'OTHER',
    SpecialOffer: 'SPECIAL_OFFER',
    Template: 'TEMPLATE',
    Support: 'SUPPORT',
    MonthlySubscription: 'MONTHLY_SUBSCRIPTION',
    YearlySubscription: 'YEARLY_SUBSCRIPTION'
} as const;
export type ProductCategory = typeof ProductCategory[keyof typeof ProductCategory];


export function ProductCategoryFromJSON(json: any): ProductCategory {
    return ProductCategoryFromJSONTyped(json, false);
}

export function ProductCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductCategory {
    return json as ProductCategory;
}

export function ProductCategoryToJSON(value?: ProductCategory | null): any {
    return value as any;
}

